import React, { useEffect, useState } from "react";
import ScrollToTopOnRouteChange from "components/ScrollToTopOnRouteChange/ScrollToTopOnRouteChange";
import { MaterialReactTable } from "material-react-table";
import { Edit, Delete } from "@mui/icons-material";
import InputField from "components/fields/InputField";
import userResources from "api/userResources";
import { toast } from "react-toastify";
import SubmitButton from "components/SubmitButton/SubmitButton";
import ConfirmModal from "components/ConfirmModal/ConfirmModal";
import PhoneInputWithCountrySelect from "react-phone-number-input";
import { FaMailBulk, FaPhone, FaWhatsapp } from "react-icons/fa";
import DateFilter from "components/DateFilter/DateFilter";
import { IoReloadOutline } from "react-icons/io5";
import Select from "react-tailwindcss-select";
import getSelectClassNames from "components/SelectFieldClasses/SelectFieldClasses";
import { selectUserInfo } from "../../../redux/userSlice";
import { useSelector } from "react-redux";
import SelectFilter from "components/SelectFilter/SelectFilter";

export default function Suppliers() {
  const userInfo = useSelector(selectUserInfo);
  const [globalFilter, setGlobalFilter] = useState("");
  const [supplierData, setSupplierData] = useState([]);
  const [editingSupplier, setEditingSupplier] = useState(null);
  const [disabled, setDisabled] = useState(false);
  const [isError, setIsError] = useState();
  const [columnsFilterValue, setColumnsFilterValue] = useState([]);
  const [updatedFilterDate, setUpdatedFilterDate] = useState("");
  const [createdAtFilterDate, setCreatedAtFilterDate] = useState("");
  const [counties, setCounties] = useState([]);
  const [state, setState] = useState([]);
  const [city, setCity] = useState([]);
  const [countryFilter, setCountryFilter] = useState();
  const [countryFilterData, setCountryFilterData] = useState([]);
  const [stateFilter, setStateFilter] = useState();
  const [stateFilterData, setStateFilterData] = useState([]);
  const [cityFilter, setCityFilter] = useState();
  const [cityFilterData, setCityFilterData] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [totalRows, setTotalRows] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [filters, setFilters] = useState({});

  const [formData, setFormData] = useState({
    name: "",
    slug: "",
    type: "",
    supplier_code: "",
    reservations_phone: "",
    reservations_email: "",
    contact_name: "",
    phone: "",
    fax: "",
    email: "",
    address: "",
    country_id: "",
    state_id: "",
    city_id: "",
    postal_code: "",
  });
  const [errors, setErrors] = useState({});

  const getSuppliers = async (pageIndex, pageSize, globalFilter, filter) => {
    setIsLoading(true);
    try {
      // Construct the params object
      const params = {
        page: pageIndex + 1, // Convert to 1-based index
        limit: pageSize,
        ...(globalFilter && { reservations_email: globalFilter }), // Add global filter if present
        ...filter, // Spread the filter object
      };

      // Call the supplier API with the params object
      const response = await userResources.supplier(params);

      // Update state with the response data
      setSupplierData(response.data.data);
      setTotalRows(response.data.paginate_data.total);
    } catch (error) {
      console.error("Error fetching supplier data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const getCountries = async () => {
    try {
      const response = await userResources.countries();
      const combinedData = response.data.data.map((item) => ({
        value: item.id,
        label: item.name,
      }));

      setCounties(combinedData);
    } catch (error) {
      console.log(error);
    }
  };
  const getCountriesForFilter = async () => {
    try {
      const response = await userResources.countries();
      setCountryFilterData(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getState = async (countryId) => {
    try {
      const response = await userResources.state(countryId);
      const combinedData = response.data.data.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      setState(combinedData);
    } catch (error) {
      console.log(error);
    }
  };

  const getStateForFilter = async (countryId) => {
    try {
      const response = await userResources.state(countryId);
      setStateFilterData(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getCity = async (params) => {
    try {
      const response = await userResources.city(params);
      const combinedData = response.data.data.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      setCity(combinedData);
    } catch (error) {
      console.log(error);
    }
  };
  const getCityForFilter = async (params) => {
    try {
      const response = await userResources.city(params);
      setCityFilterData(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const validateField = (name, value) => {
    const validations = {
      name: () => (!value ? "Supplier name is required." : ""),
      slug: () => (!value ? "Slug is required." : ""),
      type: () => (!value ? "Type is required." : ""),
      supplier_code: () => (!value ? "Supplier code is required." : ""),
      reservations_phone: () =>
        !value ? "Reservations phone is required." : "",
      reservations_email: () => {
        if (!value) return "Reservations email is required.";
        if (!/\S+@\S+\.\S+/.test(value)) return "Invalid email format.";
        return "";
      },
      // contact_name: () => (!value ? "Contact name is required." : ""),
      // phone: () => (!value ? "Phone number is required." : ""),
      // fax: () => (!value ? "Fax is required." : ""),
      // email: () => {
      //   if (!value) return "Email is required.";
      //   if (!/\S+@\S+\.\S+/.test(value)) return "Invalid email format.";
      //   return "";
      // },
      // address: () => (!value ? "Address is required." : ""),
      // country: () => (!value ? "Country is required." : ""),
      // state: () => (!value ? "State is required." : ""),
      // city: () => (!value ? "City is required." : ""),
      // postal_code: () => (!value ? "Postal code is required." : ""),
    };

    // Execute the validation function if it exists, otherwise return no error
    return validations[name]?.() || "";
  };

  const handleChange = (name, value) => {
    const fieldValue =
      typeof value === "object" && value?.target ? value.target.value : value;

    setFormData((prevData) => {
      const updatedData = {
        ...prevData,
        [name]: fieldValue,
      };

      if (name === "name" && typeof fieldValue === "string") {
        updatedData.slug = fieldValue.toLowerCase().replace(/\s+/g, "_");
      }

      return updatedData;
    });

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: validateField(name, fieldValue),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      const errorMessage = validateField(key, formData[key]);
      if (errorMessage) {
        newErrors[key] = errorMessage;
      }
    });

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      return;
    }

    setDisabled(true);
    const loadingToastId = toast.loading("Submitting...");

    try {
      if (editingSupplier) {
        await userResources.addSupplier({
          id: editingSupplier.id,
          ...formData,
        });
        setEditingSupplier(null);
        setFilters({});
        setCountryFilter(null);
        setStateFilter(null);
        setCityFilter(null);
        getSuppliers(
          pagination.pageIndex,
          pagination.pageSize,
          globalFilter,
          filters
        );

        toast.update(loadingToastId, {
          render: "Supplier updated successfully.",
          type: "success",
          isLoading: false,
          autoClose: 3000,
        });
      } else {
        await userResources.addSupplier({
          ...formData,
        });
        setFilters({});
        setCountryFilter(null);
        setStateFilter(null);
        setCityFilter(null);
        getSuppliers(
          pagination.pageIndex,
          pagination.pageSize,
          globalFilter,
          filters
        );

        toast.update(loadingToastId, {
          render: "Supplier added successfully.",
          type: "success",
          isLoading: false,
          autoClose: 3000,
        });
      }

      setFormData({
        name: "",
        slug: "",
        type: "",
        supplier_code: "",
        reservations_phone: "",
        reservations_email: "",
        contact_name: "",
        phone: "",
        fax: "",
        email: "",
        address: "",
        country_id: "",
        state_id: "",
        city_id: "",
        postal_code: "",
      });
    } catch (error) {
      console.error("Error submitting form data:", error);
      const errorMessage =
        error.response?.data?.message ||
        "Failed to submit form. Please try again.";

      toast.update(loadingToastId, {
        render: errorMessage,
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });

      if (error.response?.data?.errors) {
        const { errors } = error.response.data;
        const filteredErrors = { ...errors };
        delete filteredErrors.slug;

        setErrors(filteredErrors);
      }
    } finally {
      setDisabled(false);
    }
  };

  const suppliersColumns = React.useMemo(
    () => [
      {
        accessorKey: "id",
        header: "Supplier id",
        Cell: ({ cell }) => cell.getValue() || "N/A",
      },
      {
        accessorKey: "name",
        header: "Supplier Name",
        Cell: ({ cell }) => cell.getValue() || "N/A",
      },
      {
        accessorKey: "type",
        header: "Type",
        Cell: ({ cell }) => cell.getValue() || "N/A",
      },
      {
        accessorKey: "supplier_code",
        header: "Supplier Code",
        Cell: ({ cell }) => cell.getValue() || "N/A",
      },
      {
        accessorKey: "reservations_phone",
        header: "Reservations Phone",
        Cell: ({ cell }) => cell.getValue() || "N/A",
      },
      {
        accessorKey: "reservations_email",
        header: "Reservations Email",
        Cell: ({ cell }) => cell.getValue() || "N/A",
      },
      {
        accessorKey: "contact_name",
        header: "Contact Name",
        Cell: ({ cell }) => cell.getValue() || "N/A",
      },
      {
        accessorKey: "phone",
        header: "Phone Number",
        Cell: ({ cell }) => cell.getValue() || "N/A",
      },
      {
        accessorKey: "fax",
        header: "Fax",
        Cell: ({ cell }) => cell.getValue() || "N/A",
      },
      {
        accessorKey: "email",
        header: "Email",
        Cell: ({ cell }) => cell.getValue() || "N/A",
      },
      {
        accessorKey: "address",
        header: "Address",
        Cell: ({ cell }) => cell.getValue() || "N/A",
      },
      {
        accessorKey: "countryName",
        header: "Country",
        Cell: ({ cell }) => cell.getValue()?.name || "N/A",
        Filter: ({ column }) => (
          <SelectFilter
            options={countryFilterData}
            selectedId={countryFilter}
            setSelectedId={setCountryFilter}
            column={column}
            placeholder="Select Country..."
          />
        ),
      },
      {
        accessorKey: "stateName",
        header: "Province/State",
        Cell: ({ cell }) => cell.getValue()?.name || "N/A",
        Filter: ({ column }) => (
          <SelectFilter
            options={stateFilterData}
            selectedId={stateFilter}
            setSelectedId={setStateFilter}
            column={column}
            placeholder="Select Country..."
            disabled={countryFilter ? false : true}
          />
        ),
      },
      {
        accessorKey: "cityName",
        header: "City",
        Cell: ({ cell }) => cell.getValue()?.name || "N/A",
        Filter: ({ column }) => (
          <SelectFilter
            options={cityFilterData}
            selectedId={cityFilter}
            setSelectedId={setCityFilter}
            column={column}
            placeholder="Select Country..."
            disabled={stateFilter ? false : true}
          />
        ),
      },
      { accessorKey: "postal_code", header: "Postal/Zip" },
      {
        accessorKey: "created_at", // Adjust this to match your actual data structure
        header: "Created Date",
        filterVariant: "select",
        enableColumnFilter: true, // Enable filter for this column
        Filter: ({ column }) => (
          <DateFilter
            column={column}
            selectedDate={createdAtFilterDate}
            setSelectedDate={setCreatedAtFilterDate}
          />
        ),

        Cell: ({ cell }) => {
          const createdAt = new Date(cell.getValue());
          const date = createdAt.toLocaleDateString(); // Get the date portion
          const time = createdAt.toLocaleTimeString(); // Get the time portion

          return (
            <div className="flex flex-col">
              <p
                className="font-semibold
              "
              >
                Date: <span className="font-light">{date}</span>
              </p>{" "}
              {/* Display the date */}
              <p
                className="font-semibold
              "
              >
                Time: <span className="font-light">{time}</span>
              </p>{" "}
              {/* Display the time */}
            </div>
          );
        },
      },
      {
        accessorKey: "updated_at", // Adjust this to match your actual data structure
        header: "Updated Date",
        enableColumnFilter: true, // Enable filter for this column
        Filter: ({ column }) => (
          <DateFilter
            column={column}
            selectedDate={updatedFilterDate}
            setSelectedDate={setUpdatedFilterDate}
          />
        ),
        Cell: ({ cell }) => {
          const updatedAt = new Date(cell.getValue());
          const date = updatedAt.toLocaleDateString(); // Get the date portion
          const time = updatedAt.toLocaleTimeString(); // Get the time portion

          return (
            <div className="flex flex-col">
              <p
                className="font-semibold
                 "
              >
                Date: <span className="font-light">{date}</span>
              </p>{" "}
              {/* Display the date */}
              <p
                className="font-semibold
                 "
              >
                Time: <span className="font-light">{time}</span>
              </p>{" "}
              {/* Display the time */}
            </div>
          );
        },
      },
      {
        accessorKey: "action",
        header: "Action",
        enableColumnFilter: false, // Enable filter for this column
        Cell: ({ row }) => (
          <div className="flex space-x-2">
            <Edit
              className="cursor-pointer text-blue-500"
              onClick={() => handleEdit(row.original)}
            />
            {userInfo?.data?.role_id ===
              Number(process.env.REACT_APP_ROLE_SUPERADMIN) ||
            userInfo?.data?.role_id ===
              Number(process.env.REACT_APP_ROLE_ADMIN) ? (
              <ConfirmModal
                onConfirm={handleDelete}
                title="Delete Supplier"
                message="Are you sure you want to delete this supplier?"
                employeeId={row.original.id}
              />
            ) : null}
          </div>
        ),
      },
    ],
    [filters, countryFilterData, stateFilterData, cityFilterData]
  );

  const handleEdit = (supplier) => {
    setFormData({
      name: supplier.name || "",
      slug: supplier.slug || "",
      type: supplier.type || "",
      supplier_code: supplier.supplier_code || "",
      reservations_phone: supplier.reservations_phone || "",
      reservations_email: supplier.reservations_email || "",
      contact_name: supplier.contact_name || "",
      phone: supplier.phone || "",
      fax: supplier.fax || "",
      email: supplier.email || "",
      address: supplier.address || "",
      country_id: supplier.country_id || "",
      state_id: supplier.state_id || "",
      city_id: supplier.city_id || "",
      postal_code: supplier.postal_code || "",
    });
    setEditingSupplier(supplier);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleCancel = () => {
    setEditingSupplier(null);
    setFormData({
      name: "",
      slug: "",
      type: "",
      supplier_code: "",
      reservations_phone: "",
      reservations_email: "",
      contact_name: "",
      phone: "",
      fax: "",
      email: "",
      address: "",
      country_id: "",
      state_id: "",
      city_id: "",
      postal_code: "",
    });
    setErrors({});
  };

  const handleDelete = async (id) => {
    const loadingToastId = toast.loading("Deleting supplier...");
    try {
      await userResources.supplierDelete(id);
      toast.update(loadingToastId, {
        render: "Supplier deleted successfully.",
        type: "success",
        isLoading: false,
        autoClose: 5000,
      });
      setFilters({});
      setCountryFilter(null);
      setStateFilter(null);
      setCityFilter(null);
      getSuppliers(
        pagination.pageIndex,
        pagination.pageSize,
        globalFilter,
        filters
      );
    } catch (error) {
      console.error("Error deleting supplier:", error);
      const errorMessage =
        error.response?.data?.message ||
        "Failed to delete supplier. Please try again.";
      toast.update(loadingToastId, {
        render: errorMessage,
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });
    }
  };

  const handlePaginationChange = (updatedPagination) => {
    setPagination(updatedPagination);
  };
  const handleGlobalFilterChange = (value) => {
    setGlobalFilter(value);
  };

  // Updated handleFilterValues function
  const handleFilterValues = () => {
    const updatedFilters = {};

    columnsFilterValue.forEach((key) => {
      if (
        key.id !== "countryName" &&
        key.id !== "stateName" &&
        key.id !== "cityName" &&
        key.value !== null
      ) {
        updatedFilters[key.id] = key.value;
      }
    });

    // Add country_id, state_id, and city_id separately
    if (countryFilter) {
      updatedFilters["country_id"] = countryFilter;
    }
    if (stateFilter) {
      updatedFilters["state_id"] = stateFilter;
    }
    if (cityFilter) {
      updatedFilters["city_id"] = cityFilter;
    }

    setFilters(updatedFilters);
  };

  useEffect(() => {
    handleFilterValues();
  }, [columnsFilterValue]);

  useEffect(() => {
    getCountries();
    getCountriesForFilter();
  }, []);

  useEffect(() => {
    setState([]);
    setCity([]);
    if (formData.country_id) {
      getState(formData.country_id);
    }
  }, [formData.country_id]);

  useEffect(() => {
    setCity([]);
    const params = {
      country: formData.country_id,
      state: formData.state_id,
    };
    if (params.country && params.state) {
      getCity(params);
    }
  }, [formData?.state_id]);

  useEffect(() => {
    getSuppliers(
      pagination.pageIndex,
      pagination.pageSize,
      globalFilter,
      filters
    );
  }, [pagination, globalFilter, filters]);

  useEffect(() => {
    setStateFilterData([]);
    setCityFilterData([]);

    if (countryFilter) {
      getStateForFilter(countryFilter);
    }
  }, [countryFilter]);

  useEffect(() => {
    setCityFilterData([]);
    if (countryFilter && stateFilter) {
      getCityForFilter({ country: countryFilter, state: stateFilter });
    }
  }, [stateFilter]);

  return (
    <section className="mt-6">
      <ScrollToTopOnRouteChange />
      <div className="grid grid-cols-1 gap-6 md:grid-cols-1">
        <div className="rounded-lg bg-white p-6 shadow-md dark:bg-gray-900">
          <div className="flex items-center justify-between">
            <h3 className="mb-4 text-xl font-semibold dark:text-white">
              {editingSupplier ? "Edit Supplier" : "Add Supplier"}
            </h3>
            {editingSupplier && (
              <button
                type="button"
                onClick={handleCancel}
                className="rounded-lg border border-red-500 p-2 text-red-500 hover:bg-red-500 hover:text-white focus:outline-none"
              >
                Cancel
              </button>
            )}
          </div>
          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 items-end gap-2 sm:grid-cols-2 md:grid-cols-3">
              {/* Supplier Information */}
              <InputField
                label="Supplier Name"
                name="name"
                type="text"
                placeholder="Supplier Name"
                value={formData.name}
                onChange={(value) => handleChange("name", value)}
                state={errors.name ? "error" : ""}
                errorMessage={errors.name}
              />
              <InputField
                label="Type"
                name="type"
                type="text"
                placeholder="Type"
                value={formData.type}
                onChange={(value) => handleChange("type", value)}
                state={errors.type ? "error" : ""}
                errorMessage={errors.type}
              />
              <InputField
                label="Slug"
                name="slug"
                type="text"
                placeholder="slug"
                value={formData.slug}
                onChange={(value) => handleChange("slug", value)}
                state={errors.slug ? "error" : ""}
                errorMessage={errors.slug}
                disabled={true}
                extra={"hidden"}
              />
              <InputField
                label="Supplier Code"
                name="supplier_code"
                type="text"
                placeholder="Supplier Code"
                value={formData.supplier_code}
                onChange={(value) => handleChange("supplier_code", value)}
                state={errors.supplier_code ? "error" : ""}
                errorMessage={errors.supplier_code}
              />
              <div>
                <label
                  htmlFor="phone"
                  className="my-2 block text-sm font-medium text-gray-900 dark:text-[#09c8ff]"
                >
                  Reservations Phone
                </label>
                <div className="relative">
                  <div className="flex">
                    <PhoneInputWithCountrySelect
                      defaultCountry="CA"
                      value={formData.reservations_phone}
                      onChange={(value) =>
                        handleChange("reservations_phone", {
                          target: { value },
                        })
                      }
                      placeholder="Enter Reservations Phone"
                      className="h-10 w-full rounded-md border px-2 text-lg focus:outline-none focus:ring-2 dark:!border-white/10"
                    />
                  </div>
                  <div className="absolute right-4 top-4">
                    <FaPhone />
                  </div>
                </div>
                {errors.reservations_phone && (
                  <span className="text-sm text-red-600">
                    {errors.reservations_phone}
                  </span>
                )}
              </div>
              <InputField
                label="Reservations Email"
                name="reservations_email"
                type="email"
                placeholder="Reservations Email"
                value={formData.reservations_email}
                onChange={(value) => handleChange("reservations_email", value)}
                state={errors.reservations_email ? "error" : ""}
                errorMessage={errors.reservations_email}
              />
            </div>
            <h2 className="mt-3 rounded-md bg-gray-900 p-2 text-white dark:bg-white dark:text-gray-900">
              Personal Details
            </h2>
            <div className="grid grid-cols-1 items-end gap-2 sm:grid-cols-2 md:grid-cols-3">
              <InputField
                label="Contact Name"
                name="contact_name"
                type="text"
                placeholder="Contact Name"
                value={formData.contact_name}
                onChange={(value) => handleChange("contact_name", value)}
                state={errors.contact_name ? "error" : ""}
                errorMessage={errors.contact_name}
              />
              <div>
                <label
                  htmlFor="phone"
                  className="my-2 block text-sm font-medium text-gray-900 dark:text-[#09c8ff]"
                >
                  Phone Number
                </label>
                <div className="relative">
                  <div className="flex">
                    <PhoneInputWithCountrySelect
                      defaultCountry="CA"
                      value={formData.phone}
                      onChange={(value) =>
                        handleChange("phone", { target: { value } })
                      }
                      placeholder="Enter Phone Number"
                      className="h-10 w-full rounded-md border px-2 text-lg focus:outline-none focus:ring-2 dark:!border-white/10"
                    />
                  </div>
                  <div className="absolute right-4 top-4">
                    <FaPhone />
                  </div>
                </div>
                {errors.phone && (
                  <span className="text-sm text-red-600">{errors.phone}</span>
                )}
              </div>
              <InputField
                label="Fax"
                name="fax"
                type="text"
                placeholder="Fax"
                value={formData.fax}
                onChange={(value) => handleChange("fax", value)}
                state={errors.fax ? "error" : ""}
                errorMessage={errors.fax}
              />
              <InputField
                label="Email"
                name="email"
                type="email"
                placeholder="Email"
                value={formData.email}
                onChange={(value) => handleChange("email", value)}
                state={errors.email ? "error" : ""}
                errorMessage={errors.email}
              />

              {/* Address Details */}
              <InputField
                label="Address"
                name="address"
                type="text"
                placeholder="Address"
                value={formData.address}
                onChange={(value) => handleChange("address", value)}
                state={errors.address ? "error" : ""}
                errorMessage={errors.address}
              />
              <div>
                <label className="my-2 block text-sm font-medium text-gray-900 dark:text-[#09c8ff]">
                  Country
                </label>
                <Select
                  value={counties.find(
                    (source) => source.value === formData.country_id
                  )} // Controlled value
                  onChange={(selectedOption) => {
                    handleChange("country_id", selectedOption?.value); // Update handler
                  }}
                  options={counties} // Format options
                  isSearchable={true} // Enable search functionality
                  placeholder="Select..."
                  classNames={getSelectClassNames({
                    isDisabled: false,
                    selectProps: formData,
                    isSelected: false,
                    value: formData.country_id,
                    errorsBorder: errors.country_id ? true : false,
                  })} // Pass parameters here}
                  formatOptionLabel={(data) => (
                    <li
                      className={`mb-1 block cursor-pointer select-none truncate rounded px-2 py-2 transition duration-200 ${
                        !data.isSelected
                          ? `bg-gray-200 text-gray-900`
                          : `bg-blue-800 text-gray-200`
                      }`}
                    >
                      {data.label}
                    </li>
                  )}
                />
                {errors.country_id && (
                  <span className="text-xs text-red-500">
                    {errors.country_id}
                  </span>
                )}
              </div>
              <div>
                <label className="my-2 block text-sm font-medium text-gray-900 dark:text-[#09c8ff]">
                  Province/State
                </label>
                <Select
                  value={state.find(
                    (source) => source.value === formData.state_id
                  )} // Controlled value
                  onChange={(selectedOption) => {
                    handleChange("state_id", selectedOption?.value); // Update handler
                  }}
                  options={state} // Format options
                  isSearchable={true} // Enable search functionality
                  placeholder="Select..."
                  isDisabled={formData.country_id ? false : true}
                  classNames={getSelectClassNames({
                    isDisabled: formData.country_id ? false : true,
                    selectProps: formData,
                    isSelected: false,
                    value: formData.state_id,
                    errorsBorder: errors.state_id ? true : false,
                  })} // Pass parameters here}
                  formatOptionLabel={(data) => (
                    <li
                      className={`mb-1 block cursor-pointer select-none truncate rounded px-2 py-2 transition duration-200 ${
                        !data.isSelected
                          ? `bg-gray-200 text-gray-900`
                          : `bg-blue-800 text-gray-200`
                      }`}
                    >
                      {data.label}
                    </li>
                  )}
                />
                {errors.state_id && (
                  <span className="text-xs text-red-500">
                    {errors.state_id}
                  </span>
                )}
              </div>
              <div>
                <label className="my-2 block text-sm font-medium text-gray-900 dark:text-[#09c8ff]">
                  City
                </label>
                <Select
                  value={city.find(
                    (source) => source.value === formData.city_id
                  )} // Controlled value
                  onChange={(selectedOption) => {
                    handleChange("city_id", selectedOption?.value); // Update handler
                  }}
                  options={city} // Format options
                  isSearchable={true} // Enable search functionality
                  placeholder="Select..."
                  isDisabled={formData.state_id ? false : true}
                  classNames={getSelectClassNames({
                    isDisabled: formData.state_id ? false : true,
                    selectProps: formData,
                    isSelected: false,
                    value: formData.city_id,
                    errorsBorder: errors.city_id ? true : false,
                  })} // Pass parameters here}
                  formatOptionLabel={(data) => (
                    <li
                      className={`mb-1 block cursor-pointer select-none truncate rounded px-2 py-2 transition duration-200 ${
                        !data.isSelected
                          ? `bg-gray-200 text-gray-900`
                          : `bg-blue-800 text-gray-200`
                      }`}
                    >
                      {data.label}
                    </li>
                  )}
                />
                {errors.city_id && (
                  <span className="text-xs text-red-500">{errors.city_id}</span>
                )}
              </div>

              <InputField
                label="Postal/Zip"
                name="postal_code"
                type="text"
                placeholder="Postal/Zip"
                value={formData.postal_code}
                onChange={(value) => handleChange("postal_code", value)}
                state={errors.postal_code ? "error" : ""}
                errorMessage={errors.postal_code}
              />
              <div className="col-span-1 sm:col-span-2 md:col-span-3">
                <SubmitButton
                  editing={editingSupplier}
                  disabled={disabled}
                  add="Add Supplier"
                  edit="Update Supplier"
                />
              </div>
            </div>
          </form>
        </div>
        <MaterialReactTable
          columns={suppliersColumns}
          data={supplierData}
          state={{
            pagination,
            isLoading,
            showProgressBars: isLoading,
            showAlertBanner: isError,
            // columnFilters: columnsFilterValue,
          }} // Use both states here
          muiToolbarAlertBannerProps={
            isError
              ? {
                  color: "error",
                  children: "Error loading data",
                }
              : undefined
          }
          enableColumnFilters={true} // Pass the current visibility state
          initialState={{
            showColumnFilters: true,
          }}
          onColumnFiltersChange={setColumnsFilterValue}
          enableSorting={false}
          enableColumnOrdering={false}
          enableRowActions
          enablePagination
          onPaginationChange={handlePaginationChange}
          manualPagination
          rowCount={totalRows}
          pageCount={Math.ceil(totalRows / pagination.pageSize)}
          isLoading={isLoading}
          muiTablePaginationProps={{
            showFirstButton: true,
            showLastButton: true,
          }}
          enableGlobalFilter // Keep this true to allow global filtering
          onGlobalFilterChange={handleGlobalFilterChange} // Update the state on filter change
          globalFilter={globalFilter} // Pass the state variable to the table
          // renderTopToolbarCustomActions={({ table }) => (
          //   <div className="relative top-2 flex items-center gap-2">
          //     <IoReloadOutline
          //       size={25}
          //       className={`cursor-pointer font-semibold hover:text-green-500 ${
          //         isLoading ? "animate-spin" : ""
          //       }`}
          //       onClick={() => {
          //         setColumnsFilterValue([]); // Reset all filters
          //         setGlobalFilter(""); // Reset global filter
          //         getSuppliers(
          //           pagination.pageIndex,
          //           pagination.pageSize,
          //           "",
          //           {}
          //         ); // Refetch data without filters
          //       }}
          //     />
          //   </div>
          // )}
          // editingMode="modal" // Ensure this is correctly set
          // enableEditing // This should also be true
          renderRowActions={({ row }) => (
            <div className="flex flex-nowrap gap-4">
              <button
                className="text-xl text-primary"
                onClick={() =>
                  window.open(
                    `mailto:${row.original.reservations_email}?subject=Hello ${row.original.name}!`
                  )
                }
              >
                <FaMailBulk />
              </button>
              <button
                className="text-xl text-success"
                onClick={() => {
                  const whatsappNumber =
                    row.original.reservations_number || row.original.phone;
                  window.open(
                    `https://wa.me/${whatsappNumber.replace(
                      /\D/g,
                      ""
                    )}?text=Hello ${row.original.name}!`
                  );
                }}
              >
                <FaWhatsapp />
              </button>
            </div>
          )}
        />
      </div>
    </section>
  );
}
